import { HttpRequest, HttpHandlerFn, HttpInterceptorFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, MonoTypeOperatorFunction, pipe, throwError } from 'rxjs';
import { UiError } from '../model';
import { ErrorService } from '../services';

export const appErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const errorService = inject(ErrorService);
  const catchAppError = (): MonoTypeOperatorFunction<HttpEvent<unknown>> => {
    return pipe(
      catchError((error) => {
        const e = UiError(error);
        errorService.setError(e);
        return throwError(() => e);
      })
    );
  };

  return next(request).pipe(catchAppError());
};
